import SearchTabs from './SearchTabs'

export default SearchTabs
